import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./MyBillsUIHelpers";

const MyBillsUIContext = createContext();

export function useMyBillsUIContext() {
  return useContext(MyBillsUIContext);
}

export const MyBillsUIConsumer = MyBillsUIContext.Consumer;

export function MyBillsUIProvider({ myBillsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openUpdateMyBillsStatusDialog:
      myBillsUIEvents.openUpdateMyBillsStatusDialog,
      openPayBill:
      myBillsUIEvents.openPayBill,
      openDetails:
      myBillsUIEvents.openDetails,
  };

  return (
    <MyBillsUIContext.Provider value={value}>
      {children}
    </MyBillsUIContext.Provider>
  );
}
